let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("78c8n")).then(() => parcelRequire('85yTx'));